import { defineComponent, onMounted, watch } from 'vue'
import styles from './styles.module.scss'
import { useComponentStore } from '../../nsh5/localStores/component'

export default defineComponent({
  name: 'video-view',
  props: {
    sources: {
      // 视频资源
      type: Array as () => any[],
      default: () => [],
    },
    muted: {
      // 视频资源
      type: Boolean,
      default: true,
    },
  },
  emits: ['playEnded'],
  setup: (props, { emit }) => {
    const componentStore = useComponentStore()
    let aud: any = null
    let audTime: any = 0
    let audSwipeIns: any = null // 停留时长定时器

    watch(
      () => componentStore.swipeIndex,
      () => {
        aud.currentTime = 0
        if (componentStore.swipeIndex == 1) {
          // 开始播放
          aud.play()
          componentStore.bus.emit('videoDuration', audTime)
          initVideoDuration()
          forbidScreenInteract()
        } else {
          audSwipeIns && clearTimeout(audSwipeIns)
        }
      }
    )

    onMounted(() => {
      aud = document.getElementById('customerVideoPlayer') as HTMLVideoElement
      aud.addEventListener('loadedmetadata', function () {
        audTime = aud.duration
        // componentStore.bus.emit('videoDuration', audTime)
      })
    })

    // 阻止touch或点击事件
    const forbidScreenInteract = () => {
      const forbidTouchIns = document.querySelector('#videoContainer')
      forbidTouchIns?.addEventListener(
        'click',
        (event) => {
          event.preventDefault()
        },
        false
      )
      forbidTouchIns?.addEventListener(
        'dblclick',
        (event) => {
          event.preventDefault()
        },
        false
      )
      forbidTouchIns?.addEventListener(
        'touchstart',
        (event) => {
          event.preventDefault()
        },
        false
      )
      forbidTouchIns?.addEventListener(
        'touchmove',
        (event) => {
          event.preventDefault()
        },
        false
      )
      forbidTouchIns?.addEventListener(
        'touchend',
        (event) => {
          event.preventDefault()
        },
        false
      )
    }

    // 初始化地图停留时长
    const initVideoDuration = () => {
      audSwipeIns && clearTimeout(audSwipeIns)
      audSwipeIns = setTimeout(() => {
        handlePlayEnded()
      }, audTime * 1000)
    }

    const handlePlayEnded = () => {
      aud.pause()
      aud.currentTime = 0
      emit('playEnded')
    }

    return () => {
      return (
        <div class={styles.videoContainer} id="videoContainer">
          <video
            src={props.sources[0].src}
            style={'width:100%; object-fit: cover'}
            controls={false}
            autoplay={true}
            muted={true}
            loop={false}
            id="customerVideoPlayer"
          ></video>
        </div>
      )
    }
  },
})
